<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-row v-if="errors">
                <v-col cols="12" sm="12" md="12">
                  <v-alert
                    dense
                    v-for="(v, k) in errors"
                    :key="k"
                    outlined
                    type="error"
                  >{{ k }} {{ v }}</v-alert>
                </v-col>
              </v-row>
              <v-card-title v-if="!tc_group_id">{{ 'Add Task Group' | translate }}</v-card-title>
              <v-card-title v-if="tc_group_id">{{ 'Edit Task Group' | translate }}</v-card-title>
              <v-card-text style="position: relative">
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-text-field
                            outlined
                            :label="'Task group name' | translate"
                            name="tc_group_name"
                            v-model="tc_group_name"
                            autocomplete="off"
                            :rules="tcgroupnameRules"
                            required
                          >
                          <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              v-model="test_cases"
                              :items="testcase"
                              item-value="tc_id"
                              item-text="tc_name"
                              :label="'Tasks' | translate"
                              outlined
                              chips
                              small-chips
                              multiple
                              required
                              :no-data-text="$t('No data available')"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>                              
                            </v-autocomplete>
                        </v-col>
                      </v-row>



                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                    </v-col>
                  </v-row>
                </v-form>

                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  v-if="!tc_group_id"
                  class="mx-2"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>

                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  v-if="tc_group_id"
                  class="mx-2"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container> 
  </v-content>
</template>  

<script>
import {
  FETCH_TEST_CASE,
  FETCH_INDIVIDUAL_TEST_GROUP,
  FETCH_TEST_CASE_TEMPLATE_DATA,
  ADD_TEST_GROUP,
  UPDATE_TEST_GROUP,
  RESET_STATE
} from "@/store/actions.type";
import store from "@/store";
import { mapGetters } from "vuex"
import { mapState } from "vuex"
import { SET_SNACKBAR } from "@/store/mutations.type"
export default {
  name: "addeditTestCaseGroups",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(RESET_STATE);
    await store.dispatch(FETCH_TEST_CASE, "")
    await store.dispatch(FETCH_TEST_CASE_TEMPLATE_DATA)
    if (to.params.id) {
      await store.dispatch(FETCH_INDIVIDUAL_TEST_GROUP, to.params.id);
    }
    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE);
    next();
  },
  computed: {
    ...mapGetters(["testcase","individualtestgroup",'curLanguage', "testcasetemplatedata"]),
    ...mapState({
      errors: state => state.testcasegroup.testgrouperrors
    }),
    tcgroupnameRules(){
     return [v => !!v || "Task group name is required"]
    }
  },
  created(){
      if(Object.keys(this.individualtestgroup).length > 0){
      this.tc_group_name = this.individualtestgroup.tc_group_name
      this.tc_group_id  =   this.individualtestgroup.tc_group_id
      this.test_cases = this.individualtestgroup.test_cases
      }   
  },
  data: () => ({
    tc_group_name: null,
    tc_group_id: null,
    test_cases: [],
  }),
  methods: {
    submit() {
        if (this.$refs.form.validate()) {
          let data = {
              tc_group_name: this.tc_group_name,
              test_cases: this.test_cases
            }
            this.$store.dispatch(ADD_TEST_GROUP, data).then(resp => {
            if (resp.success) {
               store.commit(SET_SNACKBAR, {status: true, message: 'Task group added successfully'})
                this.$router.push({
                name: "testcasegroup"
                });
            }
            });            
            
        }
    },
    update() {
        if (this.$refs.form.validate()) {
        let data = {
            tc_group_name: this.tc_group_name,
            tc_group_id: this.tc_group_id,
            test_cases: this.test_cases,
            _method: 'put'
          }
        this.$store.dispatch(UPDATE_TEST_GROUP, data).then(resp => {
        if (resp.success) {
            store.commit(SET_SNACKBAR, {status: true, message: 'Task group updated successfully'})
            this.$router.push({
            name: "testcasegroup",
            });
        }
        });              
        }        
    }
  }
};
</script>